import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { Store, select } from '@ngrx/store'
import { dateGreaterThanValidator } from '@shared/directives/date-greater-than.directive'
import { Subscription } from 'rxjs'
import { ExportAuditLogsRequest } from '../audit-logs.actions'
import { isAuditLogsExportingState } from './../audit-logs.selectors'
import { formatDate } from '@angular/common'
import { toDate } from '@shared/shared.utils'

@Component({
  selector: 'app-audit-log-export',
  templateUrl: './audit-log-export.component.html',
  styleUrls: ['./audit-log-export.component.css'],
})
export class AuditLogExportComponent implements OnInit {
  public form: FormGroup
  public isLoading: boolean
  public validationErrors: any = {}
  private state$: Subscription

  constructor(private store: Store<any>, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      from: new FormControl(),
      to: new FormControl('', dateGreaterThanValidator('from')),
    })

    this.state$ = this.store
      .pipe(select(isAuditLogsExportingState))
      .subscribe((isLoading: boolean) => {
        this.isLoading = isLoading
      })
  }
  export() {
    this.validationErrors = {}
    if (this.form.valid) {
      this.store.dispatch(
        new ExportAuditLogsRequest({
          from: toDate(this.form.value.from),
          to: toDate(this.form.value.to),
        }),
      )
    } else {
      this.validationErrors = {
        to: this.form.get('to').errors?.message,
        from: this.form.get('from').errors?.message,
      }
    }
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }
}
